import { useMemo } from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { modifyString, StringModifier } from 'constants/copyHelpers';

import { useRouteToNavLevels } from './useRouteToL3';

export const useCustomNameGoalsCompanyTabs = () => {
  const { l3Options: tabs } = useRouteToNavLevels();
  const { moduleName } = useOrganisationSettings();

  const goalModuleNameTabs = useMemo(
    () =>
      tabs.map((tab) => {
        if (tab.label === 'Embedded Analytics') {
          return {
            ...tab,
            label: `Analyzing ${modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)} Achievement`,
          };
        }
        return tab;
      }),
    [tabs, moduleName]
  );
  return {
    tabs: goalModuleNameTabs,
  };
};
